import { trimLength } from './string-tools';

export const MAX_AUTHOR_NAME_LENGTH = 100;
export const ORGANIZATION_STRUCTURED_DATA = {
    '@context': 'http://schema.org/',
    '@type': 'Organization',
    '@id': 'https://www.skapiec.pl/#/schema/Organization/1',
    'url': 'https://www.skapiec.pl/',
    'logo': 'https://ocdn.eu/skapiec/logo-blue-background.svg',
    'sameAs': [
        'https://www.instagram.com/skapiec_pl/',
        'https://www.facebook.com/Skapiec'
    ],
    'contactPoint': {
        '@context': 'http://schema.org/',
        '@type': 'ContactPoint',
        '@id': 'https://www.skapiec.pl/#/schema/ContactPoint/1',
        'telephone': '12-26-00-200',
        'contactType': 'customer service',
        'areaServed': 'PL',
        'availableLanguage': 'Polish'
    }
};

export function normalizeAuthorName(name: string): string {
    return trimLength(name.trim(), MAX_AUTHOR_NAME_LENGTH) || 'Anonimowy użytkownik';
}
